import { openURL } from "../../../utils/sideEffects";

export const handleSantanaPress = (): Promise<void> => {
  const url =
    "https://steamcommunity.com/sharedfiles/filedetails/?id=1901570789";
  return openURL(url);
};
